/* eslint-disable @typescript-eslint/naming-convention */
export const I18N = {
  en: {
    wheel_front_left: "Wheel front left",
    wheel_front_right: "Wheel front right",
    wheel_rear_left: "Wheel rear left",
    wheel_rear_right: "Wheel rear right",
    head_light_left: "Head light left",
    head_light_right: "Head light right",
    rear_light_left: "Rear light left",
    rear_light_right: "Rear light right",
    third_brake_light: "Third brake light",
    mirror_left: "Mirror left",
    mirror_right: "Mirror right",
    filler_cap: "Filler cap",
    tow_bar: "Tow bar",
    exhaust: "Exhaust",
    panorama_roof: "Panorama roof",
    antenna: "Antenna",
    spare_wheel: "Spare wheel",
    parking_sensor: "Parking sensor",
    fog_light_front_left: "Fog light front left",
    fog_light_front_right: "Fog light front right",
    license_plate: "License plate",
    license_plate_holder: "License plate holder",
    brand_badge: "Brand badge",
    brand_text: "Brand text",
    engine_type: "Engine type",
    type_badge: "Type badge",
    roof_rack: "Roof rack",
    model_text: "Model text",
    driving_assistance_grill: "Driving assistance grill",
    driving_assistance_windshield: "Driving assistance windshield",
    car: "Car",
  },
  nl: {
    wheel_front_left: "Wiel linksvoor",
    wheel_front_right: "Wiel rechtsvoor",
    wheel_rear_left: "Wiel linksachter",
    wheel_rear_right: "Wiel rechtsachter",
    head_light_left: "Koplamp links",
    head_light_right: "Koplamp rechts",
    rear_light_left: "Achterlicht links",
    rear_light_right: "Achterlicht rechts",
    third_brake_light: "Derde remlicht",
    mirror_left: "Spiegel links",
    mirror_right: "Spiegel rechts",
    filler_cap: "Tankdop",
    tow_bar: "Trekhaak",
    exhaust: "Uitlaat",
    panorama_roof: "Panoramadak",
    antenna: "Antenne",
    spare_wheel: "Reserve wiel",
    parking_sensor: "Parkeersensor",
    fog_light_front_left: "Mistlamp linksvoor",
    fog_light_front_right: "Mistlamp rechtsvoor",
    license_plate: "Kenteken",
    license_plate_holder: "Kentekenhouder",
    brand_badge: "Merkembleem",
    brand_text: "Merknaam",
    engine_type: "Motortype",
    type_badge: "Typenummer",
    roof_rack: "Dakdragers",
    model_text: "Modelnaam",
    driving_assistance_grill: "Rijassistentie rooster",
    driving_assistance_windshield: "Rijassistentie voorruit",
    car: "Auto",
  },
  de: {
    wheel_front_left: "Vorderrad links",
    wheel_front_right: "Vorderrad rechts",
    wheel_rear_left: "Hinterrad links",
    wheel_rear_right: "Hinterrad rechts",
    head_light_left: "Scheinwerfer links",
    head_light_right: "Scheinwerfer rechts",
    rear_light_left: "Rücklicht links",
    rear_light_right: "Rücklicht rechts",
    third_brake_light: "Drittes Bremslicht",
    mirror_left: "Spiegel links",
    mirror_right: "Spiegel rechts",
    filler_cap: "Tankdeckel",
    tow_bar: "Anhängerkupplung",
    exhaust: "Auspuff",
    panorama_roof: "Panoramadach",
    antenna: "Antenne",
    spare_wheel: "Reserverad",
    parking_sensor: "Parking sensor",
    fog_light_front_left: "Einparkhilfe vorne links",
    fog_light_front_right: "Einparkhilfe vorne rechts",
    license_plate: "Kennzeichen",
    license_plate_holder: "Kennzeichenhalterung",
    brand_badge: "Markenemblem",
    brand_text: "Markentext",
    engine_type: "Motortyp",
    type_badge: "Typemblem",
    roof_rack: "Dachträger",
    model_text: "Modelltext",
    driving_assistance_grill: "Fahrassistenzgitter",
    driving_assistance_windshield: "Fahrassistenz-Windschutzscheibe",
    car: "Auto",
  },
};
